import { createFileRoute } from '@tanstack/react-router'
import AgreementStatement from 'Royalty/components/Agreement/AgreementStatement'

export const Route = createFileRoute(
    '/royalty_/agreement/$id/settlements/$settlementId/receiver/$contactId/$status',
)({
    component: AgreementStatement,
})
